import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../../../../services/auth.service';
import * as global from '../../../global';
import * as moment from 'moment';
import { NoteAuditoryHistoryService } from '../../../note-auditory-history/note-auditory-history.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewNoteDialog } from 'src/app/includes/transcription-create/view-note-dialog/view-note-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PatientDetailService } from 'src/app/includes/patient-detail/patient-detail.service';


@Component({
  selector: 'app-notes-list',
  templateUrl: './notes-list.component.html',
  styleUrls: ['./notes-list.component.css']
})
export class NotesListComponent implements OnInit {
  global = global;
  @Input() patientId: string;
  @Input() excludeNoteId: string;
  @Input() providerId: any;
  @Input() fromSideBar: boolean;
  notes: any[] = [];
  allnotes: any[] = [];
  displayedColumns: string[];
  dataSource: any;
  loaderId = 'note-list-loader';
  noteId: any;
  showNoteDetails: boolean = false;
  noteObj: any= {};
  company_id: string;
  currentUser: any;
  constructor(
    private patientDetailService: PatientDetailService,
    private auditoryService: NoteAuditoryHistoryService,
    private authService: AuthService,
    private _router: Router,
    private dialog: MatDialog,
    private loader: NgxUiLoaderService,
    private _activatedRoute:ActivatedRoute,
    private _authService: AuthService,
    private _route: ActivatedRoute,
  ) {
    this.displayedColumns = ['icon', 'title', 'dos', 'note_status'];
    this.currentUser = this._authService.currentUser;
    if (window.location.pathname.includes('company')) {
        this.company_id = this._route.parent.parent.snapshot.params.id || this._route.parent.snapshot.params.id;
    } else {
        this.company_id = this.currentUser.company_id;
    }
  }

  ngOnInit(): void {

    if (this.patientId) { //For url change detection in case of params
      this._activatedRoute.params.subscribe((params: any) => {
          console.log("params", params);
          this.noteId = params.note_id;
          this.initNotes();
      })
    }
  }

  async initNotes() {
    const details: any = {
      ...this.authService.authObject,
      
      patient_id: this.patientId,
      company_id: this.company_id
    };
    // if(this.providerId) {
    //   details.providerId = this.providerId;
    // }
    this.loader.startLoader(this.loaderId);

    const transcriptionsByPatientResponse: any = await this.patientDetailService.getTranscriptionsByPatientId(details).toPromise();
    if (transcriptionsByPatientResponse.status === 200) {
      // const signedNotes = transcriptionsByPatientResponse.data.array.filter(note => note.is_signed === 'true');
      // this.allnotes = signedNotes;
      // if (this.excludeNoteId) {
      //   this.notes = this.allnotes.filter(note => note._id !== this.excludeNoteId)
      // }
      this.notes = transcriptionsByPatientResponse.data.array;
      if(this.notes.length > 0) {
        this.notes.sort((a, b) => {
          const Adate = a.date_of_service;
          const Bdate = b.date_of_service;
          return new Date(Bdate).getTime() - new Date(Adate).getTime();
        });
      }
      this.dataSource = new MatTableDataSource(this.notes);
      this.loader.stopLoader(this.loaderId);

    }
  }

  getServiceDate(trans) {
    if(trans.date_obj) {
      let {year, month, day, hour, minute} = trans.date_obj;
      if(month < 10){
          month = '0' + month;
      }
      if(day < 10){
          day = '0' + day;
      }
      let str = `${month}-${day}-${year}`;
      if(hour && minute) {
          if(minute < 10){
              minute = `0${minute}`
          }
          if(hour < 10){
              hour = `0${hour}`
          }
          str += ` ${hour}:${minute}`
      } 
      return moment(str.replace(/-/g, "/")).format(global.moment_date_format2);
    } else if (trans?.filterServiceDate) {
      return moment(new Date(trans.filterServiceDate.replace(/-/g, "/"))).format('MMM DD, YYYY');
    }
    else {
      return '';
    }

  }
  getNoteStatus(status) {
    return this.auditoryService.formatOperation(status);
  }
  goToNoteEditor(note) {
    this._router.navigate([`/note-editor/${note._id}`]);

  }
  
  showViewNoteDialog(note) {
    console.log('note', note._id);
    console.log('this.noteId',this.noteId);
    if(this.noteId === note._id) {
      return;
    }
    if(this.fromSideBar == undefined) {
      const dialogRef = this.dialog.open(ViewNoteDialog, {
        width: '80%',
        //height:'80%',
        data: {
          note,
          void_census: this.checkVoidCensus(note?.rounding_sheet_id)
        }
      });
      dialogRef.beforeClosed().subscribe(async (confirm: any) => {
        if(confirm.status){
          this.notes = this.allnotes.filter(note => note._id !== confirm.id);
          this.notes.sort((a, b) => {
            const Adate = a.date_of_service;
            const Bdate = b.date_of_service;
            return new Date(Bdate).getTime() - new Date(Adate).getTime();
          });
          this.dataSource = new MatTableDataSource(this.notes);
        }
      });
    }
    else {
      this.noteObj = {
        note,
        void_census: this.checkVoidCensus(note?.rounding_sheet_id),
        fromSideBar: this.fromSideBar,
        isDnNote: true,
        isPCCNote: false
      }
      setTimeout(() => {
        this.showNoteDetails = true;  
      }, 0);
      
    }
    
  }

  closeNote(event) {
    this.showNoteDetails = false;
  }

  checkVoidCensus(patientRoundingSheet){
    if(patientRoundingSheet){
      if(patientRoundingSheet?.is_void){
        if(patientRoundingSheet.is_void === true) return false;
        else return true;
      }else{
        return true
      }
    }else{
      return true;
    }
  }
}
